import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { Bed } from './Bed'
import type { ListOfAvailabilityReduxLegacyType } from './ListOfAvailabilityReduxLegacySchema'
import type { BedTypes } from './BedType'

export const ListOfBedValidation = z.object({
  list: z.instanceof(Bed, { message: '[ListOfBed] list is required' }).array(),
})

export class ListOfBed extends Model {
  static create({ list }: z.infer<typeof ListOfBedValidation>) {
    ListOfBedValidation.parse({ list })
    return new ListOfBed(list)
  }

  static fromJSON({ json }: { json: ReturnType<ListOfBed['toJSON']> }) {
    return ListOfBed.create({
      list: json.list.map(bed => Bed.fromJSON(bed)),
    })
  }

  static empty() {
    return ListOfBed.create({ list: [] })
  }

  static fromJSONOrEmpty({ json }: { json: ReturnType<ListOfBed['toJSON']> }) {
    try {
      return ListOfBed.create({
        list: json.list.map(bed => Bed.fromJSON(bed)),
      })
    } catch {
      return ListOfBed.empty()
    }
  }

  static fromAvailabilityBoardRedux({ board }: { board: ListOfAvailabilityReduxLegacyType }) {
    if (!board.beds || board.beds.length === 0) {
      return ListOfBed.empty()
    }

    return ListOfBed.create({
      list: board.beds.map(bed =>
        Bed.fromJSON({
          type: bed.type as BedTypes,
          quantity: bed.quantity,
          description: bed.description,
        })
      ),
    })
  }

  constructor(readonly list: Bed[]) {
    super()
  }

  isEmpty() {
    return this.list.length === 0
  }

  toJSON() {
    return { list: this.list.map(item => item.toJSON()) }
  }

  get length() {
    return this.list.length
  }

  map<T>(callback: (Bed: Bed, index: number) => T) {
    return this.list.map(callback)
  }
}
